import Card from "./Card";

interface NotesCardProps {
  notes: string;
  onChange: (value: string) => void;
}

export default function NotesCard({ notes, onChange }: NotesCardProps) {
  return (
    <Card title="What I Want to Discuss">
      <textarea
        className="w-full rounded-xl p-4 text-sm text-stone-700 bg-stone-50 border border-dashed border-stone-300 focus:outline-none focus:border-[#C6D8A5]"
        style={{ minHeight: 110, lineHeight: 1.7, fontFamily: "inherit", resize: "none" }}
        value={notes}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Write down any questions or topics you want to discuss with your GP..."
      />
      <p className="text-xs text-stone-400 mt-2">
        This note will appear at the bottom of your exported PDF.
      </p>
    </Card>
  );
}
